// Self-contained data for the Luchelle Ann Cabigon real-estate concept website.
export const AGENT = {
  "slug": "luchelle-ann-cabigon-real-estate-concept",
  "name": "Luchelle Ann Cabigon",
  "shortName": "Luchelle",
  "role": "Licensed Real Estate Broker & Property Manager",
  "location": "Cebu City & Mandaue City, Cebu",
  "theme": "coastal",
  "media": {
    "hero": {
      "src": "/realestate/luchelle-ann-cabigon/486813947-1094896649323337-1096287870758457284-n.webp",
      "thumbnail": "/realestate/luchelle-ann-cabigon/486813947-1094896649323337-1096287870758457284-n-720.webp",
      "alt": "Sea-view balcony overlooking the Cebu coastline",
      "label": "Cebu living with a view",
      "type": "property"
    },
    "profile": {
      "src": "/realestate/luchelle-ann-cabigon/profile-2.webp",
      "thumbnail": "/realestate/luchelle-ann-cabigon/profile-2-720.webp",
      "alt": "Portrait of Luchelle Ann Cabigon",
      "label": "Luchelle Ann Cabigon",
      "type": "portrait"
    },
    "gallery": [
      {
        "src": "/realestate/luchelle-ann-cabigon/481919069-1078331304313205-578428403239245559-n.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/481919069-1078331304313205-578428403239245559-n-720.webp",
        "alt": "Cebu residential development exterior",
        "label": "Cebu residential opportunities",
        "type": "property"
      },
      {
        "src": "/realestate/luchelle-ann-cabigon/487180044-1098656722280663-5357424212064911726-n.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/487180044-1098656722280663-5357424212064911726-n-720.webp",
        "alt": "Bright furnished bedroom in a Cebu residence",
        "label": "Restful, move-in-ready interiors",
        "type": "property"
      },
      {
        "src": "/realestate/luchelle-ann-cabigon/487474412-1100185892127746-2810452406064509016-n.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/487474412-1100185892127746-2810452406064509016-n-720.webp",
        "alt": "Warm timber-lined residential hallway",
        "label": "Thoughtful interior finishes",
        "type": "property"
      },
      {
        "src": "/realestate/luchelle-ann-cabigon/487474422-1100185775461091-2380373361712720804-n.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/487474422-1100185775461091-2380373361712720804-n-720.webp",
        "alt": "Open-plan living and kitchen area",
        "label": "Everyday living spaces",
        "type": "property"
      },
      {
        "src": "/realestate/luchelle-ann-cabigon/488255790-1100315065448162-9202418912008847135-n.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/488255790-1100315065448162-9202418912008847135-n-720.webp",
        "alt": "Sunlit furnished living room",
        "label": "Homes selected around real life",
        "type": "property"
      },
      {
        "src": "/realestate/luchelle-ann-cabigon/489155034-1104510711695264-1958318871303708235-n.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/489155034-1104510711695264-1958318871303708235-n-720.webp",
        "alt": "Landscaped swimming pool and low-rise residences",
        "label": "Resort-style amenities",
        "type": "property"
      },
      {
        "src": "/realestate/luchelle-ann-cabigon/489487165-1105762784903390-1016325928656119384-n.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/489487165-1105762784903390-1016325928656119384-n-720.webp",
        "alt": "Waterfront towers and swimming pool",
        "label": "Cebu condominium communities",
        "type": "property"
      },
      {
        "src": "/realestate/luchelle-ann-cabigon/561636086-1268894511923549-6965568480543525160-n.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/561636086-1268894511923549-6965568480543525160-n-720.webp",
        "alt": "Luchelle attending a property-industry event",
        "label": "Present in the property community",
        "type": "business"
      },
      {
        "src": "/realestate/luchelle-ann-cabigon/616395662-1334993751980291-5091408271137262093-n.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/616395662-1334993751980291-5091408271137262093-n-720.webp",
        "alt": "Residential towers beside a landscaped pool",
        "label": "Investment and lifestyle options",
        "type": "property"
      },
      {
        "src": "/realestate/luchelle-ann-cabigon/669574638-1407111624768503-3710354415158580485-n.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/669574638-1407111624768503-3710354415158580485-n-720.webp",
        "alt": "Luchelle with a colleague at a Rockwell property event",
        "label": "Developer relationships",
        "type": "business"
      },
      {
        "src": "/realestate/luchelle-ann-cabigon/671595022-1407111174768548-860331972916773792-n.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/671595022-1407111174768548-860331972916773792-n-720.webp",
        "alt": "Luchelle documenting a property presentation",
        "label": "Researching the details",
        "type": "business"
      },
      {
        "src": "/realestate/luchelle-ann-cabigon/672690260-1407111634768502-5050076313236551377-n.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/672690260-1407111634768502-5050076313236551377-n-720.webp",
        "alt": "Luchelle on stage at a professional recognition event",
        "label": "Professional recognition",
        "type": "business"
      },
      {
        "src": "/realestate/luchelle-ann-cabigon/banner.webp",
        "thumbnail": "/realestate/luchelle-ann-cabigon/banner-720.webp",
        "alt": "Cebu Home Pages service banner featuring Luchelle",
        "label": "Guiding buyers and investors since 2011",
        "type": "brand"
      }
    ]
  },
  "accent": "#C96D4B",
  "ink": "#15333A",
  "paper": "#F6F0E7",
  "eyebrow": "Cebu homes · investments · property care",
  "headline": "Cebu property guidance that stays with you until move-in.",
  "intro": "For first-time buyers, families, OFWs and overseas investors who want clear choices, diligent guidance and one person beside them from property search to turnover.",
  "promise": "Simplified transactions. Sound, well-informed decisions.",
  "proof": [
    "Practising since 2011",
    "9 Rentpad reviews",
    "5.0 Rentpad rating",
    "PRC no. 0006014 listed publicly"
  ],
  "audiences": [
    "First-time home buyers",
    "OFWs & overseas investors",
    "Busy professionals",
    "Owners needing property management"
  ],
  "services": [
    {
      "title": "Buy & invest in Cebu",
      "text": "Condominium and house-and-lot guidance, including options for clients buying from outside Cebu or overseas."
    },
    {
      "title": "Lease with local context",
      "text": "Current public listings include Cebu IT Park and Mandani Bay-area condominium homes."
    },
    {
      "title": "End-to-end coordination",
      "text": "Property selection, reservation, document gathering, loan processing and support through turnover or move-in."
    },
    {
      "title": "Property management",
      "text": "Ongoing support for owners who need help managing cash-flowing or remotely held properties."
    }
  ],
  "process": [
    "Listen to your needs and investment horizon",
    "Present suitable, clearly explained options",
    "Coordinate reservation, paperwork and financing",
    "Stay involved through turnover, move-in or management"
  ],
  "about": "Luchelle says her work is built around diligent research, strong developer relationships and explaining project information clearly. She describes herself as a real-estate investor as well as a broker, and places particular emphasis on helping first-time buyers, families and clients based overseas.",
  "contact": {
    "phone": "+63 917 631 2463",
    "phoneHref": "+639176312463",
    "email": "luchelle@cebuhomepages.com"
  },
  "profiles": [
    {
      "label": "Facebook / Messenger",
      "href": "https://m.me/cebuhomepages",
      "imageSource": true
    },
    {
      "label": "LinkedIn",
      "href": "https://ph.linkedin.com/in/luchelle",
      "imageSource": true
    },
    {
      "label": "Rentpad profile",
      "href": "https://rentpad.com.ph/user/luchelle-ann-cabigon/e52cbbb529",
      "imageSource": true
    },
    {
      "label": "Existing website",
      "href": "https://cebuhomepages.com/about/"
    }
  ],
  "websiteAssessment": "Priority redesign: the public site still displays dated registration details, while its listings subdomain contains obvious template/demo property content and 2019-era credentials.",
  "reviewRating": 5,
  "reviewCount": 9,
  "reviews": [
    {
      "author": "Rodolfo Dalalo",
      "stars": 5,
      "summary": "Found her professional and helpful in addressing the client’s property need.",
      "source": "https://rentpad.com.ph/user/luchelle-ann-cabigon/e52cbbb529"
    },
    {
      "author": "Nash Ligtas",
      "stars": 5,
      "summary": "Says her patience, warmth and step-by-step guidance made securing a Cebu condo less stressful for an incoming student.",
      "source": "https://rentpad.com.ph/user/luchelle-ann-cabigon/e52cbbb529"
    },
    {
      "author": "Rodney Ogden",
      "stars": 5,
      "summary": "Credits her with listening closely, arranging suitable viewings, negotiating the lease and helping coordinate utilities and move-in.",
      "source": "https://rentpad.com.ph/user/luchelle-ann-cabigon/e52cbbb529"
    },
    {
      "author": "Roger Lambrou",
      "stars": 5,
      "summary": "Highlights professionalism, kindness and a commitment to making a rental or purchase worthwhile.",
      "source": "https://rentpad.com.ph/user/luchelle-ann-cabigon/e52cbbb529"
    },
    {
      "author": "Bernard Pye",
      "stars": 5,
      "summary": "Praises her knowledge of the area, development, unit and amenities, as well as her helpful manner.",
      "source": "https://rentpad.com.ph/user/luchelle-ann-cabigon/e52cbbb529"
    },
    {
      "author": "Thomas Pantaleon",
      "stars": 5,
      "summary": "Reports that she organized several Cebu viewings quickly and helped identify an apartment soon after arrival.",
      "source": "https://rentpad.com.ph/user/luchelle-ann-cabigon/e52cbbb529"
    },
    {
      "author": "Loida Apawan",
      "stars": 5,
      "summary": "Describes her as patient, accommodating and professional, and recommends working with her.",
      "source": "https://rentpad.com.ph/user/luchelle-ann-cabigon/e52cbbb529"
    },
    {
      "author": "Neal Zhu",
      "stars": 5,
      "summary": "Calls her friendly and helpful and describes their cooperation in Cebu positively.",
      "source": "https://rentpad.com.ph/user/luchelle-ann-cabigon/e52cbbb529"
    },
    {
      "author": "Gary House",
      "stars": 5,
      "summary": "Commends her friendliness and strong knowledge, saying she was a pleasure to work with.",
      "source": "https://rentpad.com.ph/user/luchelle-ann-cabigon/e52cbbb529"
    }
  ],
  "sources": [
    {
      "label": "Cebu Home Pages — About",
      "href": "https://cebuhomepages.com/about/",
      "note": "Biography, services, contact details and publicly listed credentials"
    },
    {
      "label": "Rentpad",
      "href": "https://rentpad.com.ph/user/luchelle-ann-cabigon/e52cbbb529",
      "note": "Current listings, 5.0 rating and nine review records"
    },
    {
      "label": "Cebu Home Pages listings subdomain",
      "href": "https://listings.cebuhomepages.com/",
      "note": "Evidence for website-redesign priority"
    },
    {
      "label": "LinkedIn",
      "href": "https://ph.linkedin.com/in/luchelle",
      "note": "Professional activity and image-source profile"
    }
  ]
};
